<template>
  <button
    :class="{
      'side-bar-item': true,
      ellipsis: true,
      'side-bar-item--active': active,
      'side-bar-item--small': small,
      'side-bar-item--expandable': isExpandable,
    }"
  >
    <UgIcon
      v-if="icon"
      :class="{
        'side-bar-item__icon': true,
        'side-bar-item__icon--small': small,
        'side-bar-item__icon--icon-branches': isIconBranches,
      }"
      :icon="icon"
    />
    <span v-if="text && !showMinimized" class="side-bar-item__text ellipsis">{{ text }}</span>
  </button>
</template>

<script setup lang="ts">
import { UgIcon } from "@bebit/atomic";
import type { Icon } from "@bebit/atomic";

defineProps<{
  icon?: Icon;
  text?: string;
  active?: boolean;
  small?: boolean;
  isIconBranches?: boolean;
  isExpandable?: boolean;
  showMinimized?: boolean;
}>();
</script>

<style lang="scss" scoped>
.side-bar-item {
  white-space: nowrap;
  width: 100%;
  align-items: center;
  background: none;
  border: none;
  border-radius: 4px;
  color: $colorBase900;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  height: 40px;
  justify-content: start;
  line-height: 1;
  padding: 0 22px;

  &:hover,
  &:focus-visible {
    background-color: $colorBlue100;
  }

  &--active {
    background-color: $colorBlue100;
    font-weight: bold;

    .side-bar-item__icon:not(.side-bar-item__icon--icon-branches) :deep(path) {
      fill: $colorBase900;
    }
    .side-bar-item__icon {
      color: $colorBase900;
    }
  }

  &--small {
    padding: 0 25px;
  }

  &--expandable {
    background-color: inherit;
  }

  &:focus-visible {
    background-color: $colorBlue100;
    outline: 3px solid $colorBlueA200;
    outline-offset: 1px;
  }

  &:disabled {
    background-color: transparent;
    color: $colorBase500;
    cursor: default;
    pointer-events: none;

    .side-bar-item__icon :deep(path) {
      fill: $colorBase500;
    }
  }
}

.side-bar-item__icon {
  height: 16px;
  min-height: 16px;
  min-width: 16px;
  width: 16px;
  color: $colorBase700;

  &:not(.side-bar-item__icon--icon-branches):deep(path) {
    fill: $colorBase700;
  }

  + .side-bar-item__text {
    margin-left: 9px;
  }

  &--small {
    height: 10px;
    min-height: 10px;
    min-width: 10px;
    width: 10px;

    + .side-bar-item__text {
      margin-left: 11px;
    }
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
